import React from "react";
import Grid from "@material-ui/core/Grid";
import InfoField from "../../../../../../../ui/InfoDrawer/components/InfoField";
import TextField from "@material-ui/core/TextField";

export default function LessonInfo({
  form,
  name,
  purpose,
  digitalMaterials,
  type,
  description,
  disabled,
  changeDescription
}) {
  return (
    <Grid container>
      <Grid item xs={3}>
        <InfoField name="Форма проведения" />
        <span>{form}</span>
      </Grid>
      <Grid item xs={9}>
        <InfoField name="Наименование" />
        <span>{name}</span>
      </Grid>
      <Grid item xs={12}>
        <InfoField name="Цель занятия" />
        <span>{purpose}</span>
      </Grid>
      <Grid item xs={12}>
        <InfoField name="Цифровые учебные материалы" />
        <span>{digitalMaterials}</span>
        <p>312312</p>
      </Grid>
      {type === "trainingProgram" && (
        <Grid item xs={12}>
          <TextField
            label="Описание занятия"
            value={description}
            onChange={changeDescription}
            InputLabelProps={{
              shrink: true
            }}
            fullWidth
            disabled={disabled}
            multiline
            rows="5"
          />
        </Grid>
      )}
    </Grid>
  );
}
